<template>
  <div class="app flex-row align-items-center" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3 content-header">
          <h5 style="color: white; font-family: 'Times New Roman'">
            BỘ VĂN HÓA, THỂ THAO VÀ DU LỊCH
          </h5>
          <h5
            style="
              color: white;
              font-weight: 700;
              font-family: 'Times New Roman';
            "
          >
            CỤC DU LỊCH QUỐC GIA VIỆT NAM
          </h5>
          <img src="img/logo_VN.png" style="transform: scale(0.7)" alt />
          <h2
            class="title"
            style="
              color: #fff200;
              margin-top: 10px;
              margin-bottom: 30px;
              font-family: 'Times New Roman';
              font-weight: bold;
              word-break:break-word;
            "
          >
            HỆ THỐNG CƠ SỞ DỮ LIỆU DU LỊCH VIỆT NAM
          </h2>
          <!-- <h3
            class="title"
            style="
              color: #fff200;
              margin-bottom: 20px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            KÍCH CẦU DU LỊCH NỘI ĐỊA - DU LỊCH VIỆT NAM AN TOÀN, HẤP DẪN
          </h3> -->
        </b-col>
        <b-col md="12" class="main-body">
          <div
            style="
              position: relative;
              padding: 17px;
              background-color: #4e91c9;
            "
          >
            <b-card-group>
              <b-card
                no-body
                class="text-white d-md-down-none card-image"
                style=""
              >
                <b-card-body
                  class="text-center video-intro"
                  style="padding: 0px;padding-right:0; position: relative;  "
                >
                  <div
                    style="position:relative;width:100%;height:100%;"
                  >
                    <YoutubeVue
                      class="EMMMMMMMMM"
                      style="position:relative;width:100%;height:100%;"
                      ref="youtube"
                      :videoid="play.video_id"
                      :loop="play.loop"
                      :autoplay="0"
                      :width="480"
                      :height="320"
                      @ended="onEnded"
                      @paused="onPaused"
                      @played="onPlayed"
                    />

                    <!-- <div
                      v-if="statusVideo"
                      @click="handlePlay"
                      style="position: absolute ;height: 65%;top: 0;left: 0;right: 5px;
                   background-color: rgba(50,50,50,1);z-index: 6;display:flex;justify-content: center;align-items: center;
                  cursor: pointer;"
                    >
                      <img
                        style="position:absolute; top:55%"
                        src="img/youtube1.png"
                        width="50px"
                        height="50px"
                        alt
                      />
                    </div>
                    <div
                      v-if="statusVideoMain"
                      @click="handlePlayVideoMain"
                      style="position: absolute ;width: calc(100% - 5px);height: 100%;top: 0;left: 0;right: 0;
                   background-color: rgba(0,0,0,1);z-index: 6;display:flex;justify-content: center;align-items: center;
                  cursor: pointer;"
                    >
                      <img
                        src="img/img_login.png"
                        width="100%"
                        height="100%"
                        alt
                      />
                      <img
                        style="position:absolute; left:calc( 50% - 15px)"
                        src="img/youtube1.png"
                        width="50px"
                        height="50px"
                        alt
                      />
                    </div>

                    <div
                      v-if="showIntroVideo"
                      id="ITEMM"
                      style="background-color: rgba(0,0,0,1):black;height:41%;position:absolute;z-index:5;bottom:0;display:flex;justify-content:space-between;padding-right:5px"
                    >
                      <img
                        style="padding:0"
                        v-for="(item, imgId) in filterIntroVideo(
                          temp,
                          play.video_id
                        )"
                        :key="imgId"
                        @click="applyConfig(item)"
                        :src="item.thumbnail"
                        width="33.33%"
                        alt
                      /> -->

                      <!-- test  -->
                      <!--
                      <div
                      @click="applyConfig"
                        style="position: relative ;padding:5px;height:200px; width:33.33%;"
                      >
                        <iframe
                        class="full-crs"
                          width="100%"
                          height="100%"
                          src="https://www.youtube.com/embed/7YYo-2NQmCQ"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write;
                            encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        >
                        </iframe>

                        <div class="full-sc" style="position: absolute;top: 0;width: 100%;bottom: 0;left: 0;right: 0;background: transparent;z-index: 9999;"></div>
                      </div>
                      <div
                        style="position: relative ;padding:5px;height:200px; width:33.33%;"
                      >
                        <iframe
                        class="full-crs"
                          width="100%"
                          height="100%"
                          src="https://www.youtube.com/embed/7YYo-2NQmCQ"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write;
                            encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        >
                        </iframe>

                        <div class="full-sc" style="position: absolute;top: 0;width: 100%;bottom: 0;left: 0;right: 0;background: transparent;z-index: 9999;"></div>
                      </div>
                      <div
                        style="position: relative ;padding:5px;height:200px; width:33.33%;"
                      >
                        <iframe
                        class="full-crs"
                          width="100%"
                          height="100%"
                          src="https://www.youtube.com/embed/7YYo-2NQmCQ"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write;
                            encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        >
                        </iframe>

                        <div class="full-sc" style="position: absolute;top: 0;width: 100%;bottom: 0;left: 0;right: 0;background: transparent;z-index: 9999;"></div>
                      </div>
                 -->
                      <!-- end test  -->
                    <!-- </div> -->
                  </div>
                </b-card-body>
              </b-card>
              <b-card
                no-body
                class="card-content card-content-form"
                style=""
              >
                <b-card-body style="padding: 0">
                  <b-row>
                    <b-col md="12" style="padding-right: 14px;padding-left: 15px;">
                      <div class="form-header" style="color:white;background-color:#47b3e4;padding:15px;">
                        <h5
                          style="
                            font-weight:bold;
                            font-size:16px;
                          "
                        >
                          HƯỚNG DẪN ĐĂNG KÝ
                        </h5>
                        <p><span class="bold step-blue">BƯỚC 1</span>. Chọn <a href="/dangky" style="color:#fff; text-decoration: underline;" class="bold">ĐĂNG KÝ</a> và khai báo thông tin theo mẫu</p>
                        <p><span class="bold step-blue">BƯỚC 2</span>. Kiểm tra tin nhắn và xác thực mã OTP</p>
                        <p><span class="bold step-blue">BƯỚC 3</span>. <span class="bold">ĐĂNG NHẬP</span> hệ thống</p>
                      </div>
                    </b-col>
                    <b-col md="12">
                      <b-row class="form-login-qr" style="">
                        <b-col md="6">
                          <b-alert
                            variant="danger"
                            dismissible
                            :show="mData.dataDefault.showDismissibleAlert"
                            @dismissed="mData.dataDefault.showDismissibleAlert = false"
                            >{{ mData.dataDefault.error }}</b-alert
                          >

                          <el-form
                            :model="mData.dataForm"
                            :rules="mData.validForm"
                            ref="myForm"
                            label-width="100%"
                            label-position="top"
                            @submit.native.prevent
                            class="form-login-custom"
                          >
                            <el-form-item class="el-form-login-custom" :label="aLang.login_account" prop="account">
                              <el-input
                                v-model.trim="mData.dataForm.account"
                                clearable
                              ></el-input>
                            </el-form-item>

                            <el-form-item class="el-form-login-custom" :label="aLang.login_password" prop="password">
                              <el-input
                                v-model.trim="mData.dataForm.password"
                                show-password
                              ></el-input>
                            </el-form-item>

                            <el-form-item label prop="remember" style="color:#0c66ad;margin-bottom: 20px;">
                              <b-row>
                                <b-col cols="6" class="remember-pass">
                                  <el-checkbox v-model="mData.dataForm.remember">{{
                                    aLang.login_remember
                                  }}</el-checkbox>
                                </b-col>
                                <b-col cols="6" class="forgot-pass">
                                  <b-link to="/auth/forgotPassword" style="color:#0c66ad;">Quên mật khẩu?</b-link>
                                </b-col>
                              </b-row>
                            </el-form-item>
                            <el-form-item class="text-center form-btn" style="margin-bottom:0;">
                              <el-button
                                class="btn-register"
                                style=""
                                type="success"
                                @click="fn_register()"
                                >Đăng ký</el-button
                              >
                              <el-button
                                class="btn-login"
                                style="background: #0c66ad; border: 1px solid #0c66ad;"
                                type="primary"
                                @click="fn_submitForm()"
                                v-ladda
                                native-type="submit"
                                >{{ aLang.login }}</el-button
                              >
                              <div class="qr-code-mobile">
                                <p class="box-image-qr-text-mobile">Quét để tải ứng dụng Du lịch Việt Nam</p>
                                <div>
                                  <img src="img/qr.png" alt="" />
                                </div>
                                <div class="hddk_ctlh-mobile" style="margin-bottom: 10px;">
                                  <b-link
                                    class="hddk_ctlh-a"
                                    @click="viewHddkCtlhHandler"
                                  >
                                    <p>HƯỚNG DẪN ĐĂNG KÝ CÔNG TY LỮ HÀNH</p>
                                  </b-link>
                                </div>
                                <div class="hdsd-mobile" style="margin-bottom: 10px;">
                                  <b-link class="hdsd-a" @click="viewHdsdWebHandler">
                                    <p>HƯỚNG DẪN ĐĂNG KÝ VÀ ĐÁNH GIÁ</p>
                                  </b-link>
                                </div>
                                <div style="cursor:pointer;" @click="fn_call" class="phone-switchboard-mobile">
                                  <p class="bold switchboard-text-mobile">TỔNG ĐÀI HỖ TRỢ <span class="bold phone-mobile">19006888</span></p>
                                </div>
                              </div>
                            </el-form-item>
                          </el-form>
                        </b-col>
                        <b-col md="6" style="padding: 0 10px 0 0;">
                          <div class="body-right">
                            <div class="box-image-qr" style="text-align: center;margin-bottom: 20px;">
                              <p class="box-image-qr-text">Quét để tải ứng dụng Du lịch Việt Nam</p>
                              <div class="div_qr">
                                <img src="img/qr.png" alt="" />
                              </div>
                            </div>
                            <b-row>
                              <b-col sm="4" style="padding: 0 5px 0 0;">
                                <div class="hddk_ctlh">
                                  <b-link
                                    class="hddk_ctlh-a"
                                    @click="viewHddkCtlhHandler"
                                  >
                                    <p>HƯỚNG DẪN ĐĂNG KÝ</p>
                                    <p>CÔNG TY LỮ HÀNH</p>
                                  </b-link>
                                </div>
                              </b-col>
                              <b-col sm="4" style="padding: 0 5px 0 0;">
                                <div class="hdsd">
                                  <b-link class="hdsd-a" @click="viewHdsdWebHandler">
                                    <p>HƯỚNG DẪN</p>
                                    <p>ĐĂNG KÝ VÀ ĐÁNH GIÁ</p>
                                  </b-link>
                                </div>
                              </b-col>
                              <b-col sm="4" style="padding: 0 5px 0 0;">
                                <div @click="fn_call" class="phone-switchboard">
                                  <p class="bold switchboard-text">TỔNG ĐÀI HỖ TRỢ</p>
                                  <p class="bold phone">19006888</p>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-card-group>
            <el-dialog
              :close-on-click-modal="true"
              :visible.sync="isViewHddkCtlh"
              width="95%"
              top="20px"
            >
              <div class="circle">
                <div class="e-loadholder">
                  <div class="m-loader">
                    <span class="e-text">Loading</span>
                  </div>
                </div>
                <div id="particleCanvas-Blue"></div>
                <div id="particleCanvas-White"></div>
              </div>
              <iframe :src="aExtension.urlHddkCtlh"></iframe>
              <div class="button-download-wrapper text-center">
                <el-button
                  @click="
                    downloadFile(
                      aExtension.urlFilesTemplate.HddkCtlh,
                      'HDSDSafectlhVconvert'
                    );
                    isViewHdsdCsdvdl = false;
                  "
                  type="info"
                  plain
                  >Tải xuống HDĐK</el-button
                >
              </div>
            </el-dialog>
            <el-dialog
              :close-on-click-modal="true"
              :visible.sync="isViewHdsdApp"
              width="95%"
              top="20px"
            >
              <div class="circle">
                <div class="e-loadholder">
                  <div class="m-loader">
                    <span class="e-text">Loading</span>
                  </div>
                </div>
                <div id="particleCanvas-Blue"></div>
                <div id="particleCanvas-White"></div>
              </div>
              <iframe :src="aExtension.urlHdsdAPP"></iframe>
              <div class="button-download-wrapper text-center">
                <el-button
                  @click="
                    downloadFile(
                      aExtension.urlFilesTemplate.HdsdDownload,
                      'HuongDanSuDung-App'
                    );
                    isViewHdsdApp = false;
                  "
                  type="info"
                  plain
                  >Tải xuống HDSD</el-button
                >
              </div>
            </el-dialog>
            <el-dialog
              :close-on-click-modal="true"
              :visible.sync="isViewHdsdCsdvdl"
              width="95%"
              top="20px"
            >
              <div class="circle">
                <div class="e-loadholder">
                  <div class="m-loader">
                    <span class="e-text">Loading</span>
                  </div>
                </div>
                <div id="particleCanvas-Blue"></div>
                <div id="particleCanvas-White"></div>
              </div>
              <iframe :src="aExtension.urlHdsdCsdvdl"></iframe>
              <div class="button-download-wrapper text-center">
                <el-button
                  @click="
                    downloadFile(
                      aExtension.urlFilesTemplate.HdsdCsdvdlDownload,
                      'HuongDanSuDung-Web'
                    );
                    isViewHdsdCsdvdl = false;
                  "
                  type="info"
                  plain
                  >Tải xuống HDSD</el-button
                >
              </div>
            </el-dialog>
          </div>
        </b-col>
        <b-col md="12" class="mt-3">
          <div class="box-address" style="max-width: 1230px;margin: 0 auto;flex-wrap:nowrap;overflow: auto;">
            <div class="text-center link-address">
              <b-link class="link" href="http://vietnamtourism.gov.vn">
                <div class="box-image">
                  <img class="image" src="img/logo-web.png" />
                </div>
                <span class="text-link"
                  >http://vietnamtourism.gov.vn</span
                ></b-link
              >
            </div>
            <div class="text-center link-address">
              <b-link
                class="link"
                href="https://www.youtube.com/c/vietnamtourismmedia"
              >
                <div class="box-image">
                  <img
                    class="image"
                    style="max-height: 80%"
                    src="img/youtube.png"
                  />
                </div>
                <span class="text-link"
                  >https://www.youtube.com/c/vietnamtourismmedia</span
                >
              </b-link>
            </div>
            <div class="text-center link-address">
              <b-link class="link" href="https://zalo.me/tongcucdulich">
                <div class="box-image">
                  <img class="image" src="img/zalo.png" />
                </div>
                <span class="text-link">https://zalo.me/tongcucdulich</span>
              </b-link>
            </div>
            <div class="text-center link-address">
              <b-link class="link" href="https://facebook.com/vnattitc">
                <div class="box-image">
                  <img class="image" src="img/fb.png" />
                </div>
                <span class="text-link">https://facebook.com/vnattitc</span>
              </b-link>
            </div>
            <div class="text-center link-address">
              <b-link
                class="link"
                href="http://nentangso.vietnamtourism.gov.vn"
              >
                <div class="box-image">
                  <img class="image" src="img/nentangso.png" />
                </div>
                <span class="text-link"
                  >http://nentangso.vietnamtourism.gov.vn</span
                >
              </b-link>
            </div>
          </div>
          <!-- <div class="app-qr-mobile">
            <div class="image1 image-box">
              <img src="img/qr.png" />
              <p class="mb-0 text-center mt-1">Quét để tải app</p>
            </div>
            <div class="image-box">
              <b-link @click="viewHdsdAppHandler">
                <img src="img/hssd_app.png" />
              </b-link>
            </div>
            <div class="image-box box-image-hdsd-web">
              <b-link @click="viewHdsdWebHandler">
                <img src="img/hssd_web.png" />
              </b-link>
            </div>
          </div> -->
        </b-col>
        <b-col md="12" class="text-center mt-5">
          <p style="color:#6bcefb;font-size: 12px;">THÔNG TIN LIÊN HỆ, HỖ TRỢ: Điện thoại: 1900 6888; Email: info@vietsens.vn;</p>
        </b-col>
      </b-row>
    </div>
    <el-dialog
      class="list_account"
      title="Chọn tài khoản bạn muốn đăng nhập"
      :visible.sync="haveManyAccounts"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-radio-group v-model="mData.accountChooseFromDialog">
          <b-row>
            <b-col md="12" v-for="(item,index) in mData.listAccount" :key="index">
              <el-radio :label="item.Account">{{item.Account}} - {{item.Ho_ten}}</el-radio>
            </b-col>
          </b-row>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fn_login(mData.accountChooseFromDialog,mData.dataForm.password)">Chọn</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import { YoutubeVue } from "youtube-vue";
import AccountApi from '../../moduleApi/AccountApi';

export default {
  components: {
    YoutubeVue
  },
  data() {
    return {
      haveManyAccounts: false,
      width:window.screen.width,
      height:window.screen.height,
      setT: "",
      temp: [
        {
          video_id: "usI5vkUt8nI",
          thumbnail: "https://i.ytimg.com/vi/cfh58-jDZyI/maxresdefault.jpg"
        },
        {
          video_id: "b1UtffzfG64",
          thumbnail: "https://i.ytimg.com/vi/W1kTDggZ1y4/maxresdefault.jpg"
        },
        {
          video_id: "oQN5vB3VtUA",
          thumbnail: "https://i.ytimg.com/vi/oQN5vB3VtUA/maxresdefault.jpg"
        },
        {
          video_id: "9H3rKAuU25Q",
          thumbnail: "/img/img_login.png"
        }
      ],
      play: {
        video_id: "Dy13r8ikfWQ", // video_id là id của video trên youtube sau v= ở url,
        thumbnail:
          "https://ephoto360.com/uploads/w450/2020/12/24/thiep-video-tet-tan-suu_af6e9.jpg"
      },
      statusVideo: false,
      statusVideoMain: true,
      showIntroVideo: true,
      // videoId: "aNCiM92I_g0",
      // listVideo: ["aNCiM92I_g0", "usI5vkUt8nI", "SNES5Y-tYxM"],
      aLang: LanguageService.lang,
      aExtension: ExtensionService,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false
        },
        dataForm: {
          account: "",
          password: "",
          remember: true
        },
        validForm: {
          account: [ValidService.required],
          password: [ValidService.required]
        },
        accountChooseFromDialog: "",
        listAccount: [],
        mailAccount: ""
      },
      isViewHdsdApp: false,
      isViewHdsdCsdvdl: false,
      isViewHddkCtlh: false
    };
  },
  methods: {
    fn_register(){
      window.location.href="/dangky"
    },
    fn_call(){
      window.location.href="tel:19006888"
    },
    filterIntroVideo(items, name) {
      return items.filter(item => item.video_id !== name);
    },
    handlePlay() {
      this.$refs.youtube.player.playVideo();
    },
    handlePlayVideoMain() {
      this.statusVideoMain = false;
      this.$refs.youtube.player.playVideo();
    },
    applyConfig(item) {
      this.play.video_id = item.video_id;
      this.play.thumbnail = item.thumbnail;
      // this.statusVideo = false;
      this.showIntroVideo = false;
      this.$refs.youtube.player.playVideo();
    },
    playCurrentVideo() {
      applyConfig();
      this.$refs.youtube.player.playVideo();
      this.statusVideo = false;
      this.showIntroVideo = false;
    },
    stopCurrentVideo() {
      this.$refs.youtube.player.stopVideo();
    },
    pauseCurrentVideo() {
      this.$refs.youtube.player.pauseVideo();
    },
    onEnded() {
      // console.log("## OnEnded");
      // this.$refs.youtube.player.playVideo();
      this.statusVideo = true;
      this.showIntroVideo = true;
    },
    onPaused() {
      // console.log("## OnPaused");
      this.setT = setTimeout(() => {
        this.showIntroVideo = true;
      }, 150);
    },
    onPlayed() {
      clearTimeout(this.setT);
      // console.log("## OnPlayed");
      this.statusVideo = false;
      this.showIntroVideo = false;
    },

    fn_submitForm() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.mailAccount = this.mData.dataForm.account;
          const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          let isMail = mailRegex.test(this.mData.dataForm.account.toLowerCase());
          if(isMail === true){
            this.mData.mailAccount = this.mData.dataForm.account;
            let data = {
              email: this.mData.dataForm.account
            }
            const res = await AccountApi.getAccountByEmail(data);
            if(res.result && res.result.length > 0){
              this.mData.dataDefault.showDismissibleAlert = false;
              if(res.result.length == 1){
                // this.mData.dataForm.account = res.result[0].Account;
                let account = res.result[0].Account;
                this.fn_login(account,this.mData.dataForm.password);
              }else if(res.result.length > 1){
                this.haveManyAccounts = true;
                this.mData.listAccount = res.result;
              }
            }else{
              this.mData.dataDefault.showDismissibleAlert = false;
              this.fn_login(this.mData.dataForm.account,this.mData.dataForm.password);
            }
          }else if(isMail === false){
            this.fn_login(this.mData.dataForm.account,this.mData.dataForm.password);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_login(account,password){
      if(account == ""){
        window.toastr.error("Vui lòng chọn tài khoản!");
        // alert("Vui lòng chọn tài khoản!")
        return
      }
      this.haveManyAccounts = false;
      this.mData.dataForm.account = account;
      AuthService.login(
        account,
        password
      )
        .then(() => {
          this.$router.push({ name: "Admin-Home" });
        })
        .catch(() => {
          if(this.mData.mailAccount != ""){
            this.mData.dataForm.account = this.mData.mailAccount;
          }
          this.mData.mailAccount = this.mData.dataForm.account;
          this.mData.dataDefault.showDismissibleAlert = true;
          this.mData.dataDefault.error = LanguageService.lang.login_error;
        });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    viewHdsdAppHandler() {
      this.isViewHdsdApp = true;
    },
    viewHdsdWebHandler() {
      this.isViewHdsdCsdvdl = true;
    },
    viewHddkCtlhHandler(){
      this.isViewHddkCtlh = true;
    },
    downloadFile(url, filename) {
      let downloadLink = document.createElement("a");
      downloadLink.href = url;
      if (filename) downloadLink.download = filename;
      // Firefox requires the link to be added to the DOM
      // before it can be clicked.
      downloadLink.onclick = function() {
        document.body.removeChild(downloadLink);
      };
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);

      downloadLink.click();
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
.circle {
  display: block;
}

#login-page {
  background-image: url("~/img/background.jpg");
  background-size: cover;
  position: relative;
  z-index: 4000;
}
::v-deep .el-form-item__label {
  font-weight: 700;
}

::v-deep .el-input__inner {
  border-radius: 12px;
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.5);
}

.box-image {
  height: 40px;
  width: 100%;
  position: relative;
}
.image {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  object-position: center;
}

.link {
  color: white;
  font-size: 12px;
}
.box-address {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}
.box-address::-webkit-scrollbar-track {
    background-color: transparent;
}

.box-address::-webkit-scrollbar-thumb {
      background-color: transparent;
}

.box-address::-webkit-scrollbar-button {
      background-color: transparent;
}

.box-address::-webkit-scrollbar-corner {
      background-color: transparent;
}
.card-content {
  max-width: 36%;
}

.app-qr {
  position: absolute;
  /*right: calc((105px + 105px + 40px) * -1);*/
  right: -345px;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.image-box {
  display: block;
  width: 105px;
  height: 126px;
  margin-left: 10px;
  margin-top: 10px;
}

.image-box p {
  color: #fff;
}

.image-box img {
  object-fit: contain;
  object-position: center;
}

/*.image1 {
  margin-right: 20px;
}*/

.app-qr-mobile {
  display: none;
}

/* .box-image-hdsd,
.box-image-qr {
  display: none;
} */

.button-register {
  display: block;
  text-decoration: none;
  margin: 10px auto 0;
  padding: 13px 25px;
  width: 135px;
  font-size: 14px;
}

::v-deep .el-dialog__wrapper {
  background-color: #00000055;
}

::v-deep .el-dialog {
  margin-top: 20px !important;
  margin-bottom: 0;
  width: calc(100% - 40px) !important;
  height: calc(100% - 40px);
}

::v-deep .el-dialog__header {
  border: none;
  background: none;
  padding: 0;
}

::v-deep .el-dialog__headerbtn {
  top: 0px;
  right: 0;
  width: 55px;
  height: 55px;
  background-color: #ddd;
  font-size: 20px;
  border-bottom-left-radius: 4px;
  z-index: 2000;
}

::v-deep .el-dialog__body {
  height: 100%;
  padding: 0;
}

::v-deep .el-dialog__body iframe {
  margin: 0 auto;
  display: flex;
  width: 100%;
  height: calc(100% - 50px);
  border-width: 0;
  background-color: transparent;
  z-index: 1000;
  position: relative;
}

::v-deep .el-dialog__body .button-download-wrapper {
  padding-top: 10px;
}

@media screen and (max-width: 1820px) {
  .app-qr {
    flex-direction: column;
    /*right: calc((100vw - 1140px + 210px) / -4);*/
    right: -115px;
  }

  /*.image1 {
    margin-bottom: 20px;
    margin-right: 0;
  }*/
}
@media screen and (min-width: 1820.98px) {
  .app-qr .image-box-wrap {
    display: flex;
  }
  .app-qr {
    flex-direction: column;
    /* right:-345px */
    right: -235px;
  }
  .app-qr .image1.image-box img {
    max-width: 220px;
  }
  .image1 {
    width: 220px;
    height: 245px;
  }
  /* .card-content{
    right: -115px;
  } */
  /* .video-intro{
    width:calc( 100% + 100px );
  } */
}

@media screen and (max-width: 1460px) {
  /* .link-address {
    width: 50%;
    margin: 5px 0;
  } */
  /* .content-header {
    margin-bottom: 40px;
  } */
  .box-address {
    flex-wrap: wrap;
    /* justify-content: space-around; */
  }
  .app-qr {
    display: none;
  }
  .app-qr-mobile {
    display: flex;
    flex-direction: row;
    /* justify-content: space-around; */
    margin: 20px 0;
  }
}
@media screen and (max-width: 1199px) {
  .card-image {
    display: none;
  }
  .card-content {
    max-width: 400px;
    margin: auto !important;
  }

  .text-link {
    /* display: none; */
  }

  .link-address {
    width: auto;
    margin: 0 10px;
  }

  .box-address {
    /* justify-content: center; */
  }
  .image {
    position: unset;
    transform: translate(0, 0);
  }

  .app-qr {
    /*right: calc((100vw - 400px - 218px) / 8);*/
    right: 150px;
    display: flex;
  }

  .app-qr-mobile {
    display: none;
  }
}

@media screen and (max-width: 991px) {
  .card-image {
    display: none;
  }
  .card-content {
    max-width: 400px;
    margin: auto !important;
  }
  .app-qr {
    /*right: calc((100vw - 400px - 218px) / 8);*/
    right: 30px;
    display: flex;
  }

  .app-qr-mobile {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h5 {
    font-size: 14px;
  }
  .app-qr {
    display: none;
  }
  .text-link {
    /* display: none; */
  }
  .link-address {
    width: auto;
    margin: 0 10px;
  }
  .box-address {
    /* justify-content: space-between; */
  }
  .image {
    position: unset;
    transform: translate(0, 0);
  }
  .text {
    font-size: 12px;
  }
  .title {
    margin-bottom: 0px !important;
  }

  .button-register {
    display: block;
    margin: 10px auto 0;
    width: 100px;
  }

  .box-image-hdsd {
    position: absolute;
    width: calc((100% - 160px) / 4);
    top: -57px;
    left: 10px;
    display: block;
  }
  .box-image-hdsd-web {
    left: calc(25% - 20px);
  }
  .box-image-hdsd div {
    padding-bottom: 100%;
    width: 100%;
  }
  .box-image-hdsd img {
    /*position: absolute;*/
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    top: 0;
    left: 0;
  }

  .box-image-qr {
    position: absolute;
    width: calc((100% - 30px) / 3);
    top: -105px;
    right: 5px;
    display: block;
  }
  .box-image-qr div {
    padding-bottom: 100%;
    width: 100%;
  }
  .box-image-qr img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    top: 0;
    left: 0;
  }
}
.box-image-qr-text{
  text-transform: uppercase;
  font-size:12px;
  font-weight: bold;
  color: #ff712b;
  margin-bottom: 0.3rem;
}
.box-image-qr-text-mobile{
  text-transform: uppercase;
  font-size:10.5px;
  font-weight: bold;
  color: #ff712b;
  margin-bottom: 0.3rem;
  white-space: nowrap;
}
@media screen and (max-width: 375px) {
  .box-image-qr-text {
    font-size: .7rem;
  }
}
@media (min-width: 1200px){
  .container {
      max-width: 1650px;
  }
}
.card-image{
  background: transparent;
  border: none;
  max-width: 821px;
}
.card-content-form{
  border-radius: 0 ;
  max-width: 750px;
  border-top: 0;
  border-left: 0;
}
.card-content-form .form-login-custom{
  padding: 0px 15px;
}
.card-content-form .form-login-custom .btn-register{
  background: #66c23a;
  border: 1px solid #66c23a;
}
.card-content-form .form-login-qr{
  padding: 10px 30px 21px 25px;
}
.card-content-form .form-header p{
  margin: 0;
  line-height:25px;
}
.card-content-form .form-header .step-blue{
  color:#27fee2;
}
.btn-register{
  padding: 10px 32px;
}
.btn-login{
  padding: 10px 25px;
}
.phone-switchboard{
  text-align: center;
  padding: 2px 0 2px 0;
  background: #33ace3;
  border-radius: 8px;
  transition: 0.5s ease-in-out all;
}
.phone-switchboard:hover{
  -ms-transform: scale(1.1); /* IE 9 */
  transform: scale(1.1); /* Standard syntax */
  cursor: pointer;
}
.phone-switchboard p{
  margin-bottom: 0;
  color: #fff;
  font-size: 11px;
}
.phone-switchboard .phone{
  font-size: 16px;
  letter-spacing: 2px;
}
.hddk_ctlh:hover{
  -ms-transform: scale(1.1); /* IE 9 */
  transform: scale(1.1); /* Standard syntax */
}
.hddk_ctlh{
  text-align: center;
  background: #66c23a;
  padding: 7px 0 7px 0;
  border-radius: 8px;
  transition: 0.5s ease-in-out all;
}
.hddk_ctlh .hddk_ctlh-a{
  /* padding-bottom: 30px; */
  text-decoration: none;
  color: #fff;
  font-size:9px;
  font-weight: bold;
}
.hddk_ctlh .hddk_ctlh-a p {
  margin-bottom: 0;
  line-height: 15px;
}
.hdsd:hover{
  -ms-transform: scale(1.1); /* IE 9 */
  transform: scale(1.1); /* Standard syntax */
}
.hdsd{
  text-align: center;
  background: #ed8d1e;
  padding: 7px 0 7px 0;
  border-radius: 8px;
  transition: 0.5s ease-in-out all;
}
.hdsd .hdsd-a{
  /* padding-bottom: 30px; */
  text-decoration: none;
  color: #fff;
  font-size:9px;
  font-weight: bold;
}
.hdsd .hdsd-a p {
  margin-bottom: 0;
  line-height: 15px;
}
.phone-switchboard-mobile{
  text-align: center;
  padding: 0 0 0 0;
  background: #33ace3;
  border-radius: 8px;
}
.phone-switchboard-mobile p{
  margin-bottom: 0;
  color: #fff;
  font-size: 10px;
}
.phone-switchboard-mobile .phone-mobile{
  padding-left: 10px;
  font-size: 13px;
  letter-spacing: 2px;
}
.hddk_ctlh-mobile{
  text-align: center;
  background: #66c23a;
  padding: 9px 0 10px 0;
  border-radius: 8px;
}
.hddk_ctlh-mobile .hddk_ctlh-a{
  /* padding-bottom: 30px; */
  text-decoration: none;
  color: #fff;
  font-size:10px;
  font-weight: bold;
}
.hddk_ctlh-mobile .hddk_ctlh-a p {
  margin-bottom: 0;
  line-height: 13px;
}
.hdsd-mobile{
  text-align: center;
  background: #ed8d1e;
  padding: 9px 0 10px 0;
  border-radius: 8px;
}
.hdsd-mobile .hdsd-a{
  /* padding-bottom: 30px; */
  text-decoration: none;
  color: #fff;
  font-size:10px;
  font-weight: bold;
}
.hdsd-mobile .hdsd-a p {
  margin-bottom: 0;
  line-height: 13px;
}
.el-form-item.is-required:not(.is-no-asterisk).el-form-item__label-wrap>.el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
  content: '';
  margin-right: 4px;
}
::v-deep .list_account .el-radio, ::v-deep .list_account .el-radio__input {
    white-space: normal;
    word-break: initial;
  }
@media screen and (max-width: 425px) {
  h2{
    font-size: 21px;
  }
  .content-header{
    margin-bottom: 30px;
  }
  .title{
    padding: 0 72px;
  }
  .card-content-form .form-login-custom .forgot-pass{
    text-align: right;
  }
  .card-content-form .form-login-custom .forgot-pass a{
    padding-right: 10px;
  }
  .card-content-form .form-login-custom .btn-register{
    padding: 10px 25px;
  }
  .card-content-form .form-login-custom .btn-login{
    padding: 10px 18px;
  }
  .qr-code-mobile{
    max-width: 280px;
    margin: 0 auto;
    margin-top: 10px;
  }
}
@media screen and (max-width: 400px) {
  h2{
    font-size: 21px;
  }
  .content-header{
    margin-bottom: 30px;
  }
  .title{
    padding: 0 30px;
  }
  .card-content-form .form-login-custom .remember-pass{
    flex: 0 0 100%;
    max-width: 100%;
  }
  .card-content-form .form-login-custom .forgot-pass{
    flex: 0 0 100%;
    max-width: 100%;
  }
  .card-content-form .form-login-custom .remember-pass{
    text-align: center;
  }
  .card-content-form .form-login-custom .forgot-pass{
    text-align: center;
  }
  .card-content-form .form-login-custom .forgot-pass a{
    padding-right: 10px;
  }
  .card-content-form .form-login-custom .btn-register{
    padding: 10px 15px;
  }
  .card-content-form .form-login-custom .btn-login{
    padding: 10px 8px;
  }
}
@media screen and (max-width: 558px) {

}
@media screen and (max-width: 767px) {
  .qr-code-mobile{
    max-width: 220px;
    margin: 0 auto;
    margin-top: 10px;
  }
  .body-right{
    display: none;
  }
  .card-content-form .form-login-custom{
    padding: 0;
  }
  .content-header{
    margin-bottom: 30px;
  }
}
@media screen and (min-width: 768px) {
  .qr-code-mobile{
    display: none;
  }
}
@media screen and (max-width: 1366px) {
  .card-content-form .form-login-qr{
    padding: 10px 30px 23px 25px;
  }
}
@media (min-width: 1200px) and (max-width: 1366px) {
  .box-image-qr-text{
    font-size: 10.5px;
  }
  .hdsd .hdsd-a{
    font-size: 9px;
  }
  .phone-switchboard .switchboard-text{
    font-size: 10px;
    padding-top: 4px;
  }
  .phone-switchboard .phone{
    font-size: 14px;
    padding-bottom: 0;
  }
}
.div_qr{
  max-width: 160px;
  margin: 0 auto;
}
@media (min-width: 1200px) and (max-width: 1450px) {
  .card-content-form .form-login-custom .remember-pass{
    flex: 0 0 100%;
    max-width: 100%;
  }
  .card-content-form .form-login-custom .forgot-pass{
    flex: 0 0 100%;
    max-width: 100%;
  }
  .card-content-form .form-login-custom .remember-pass{
    text-align: left;
  }
  .card-content-form .form-login-custom .forgot-pass{
    text-align: left;
  }
  .card-content-form .form-login-custom .forgot-pass a{
    padding-right: 10px;
  }
  .card-content-form .form-login-custom .btn-register{
    padding: 10px 15px;
  }
  .card-content-form .form-login-custom .btn-login{
    padding: 10px 8px;
  }
  .remember-pass .el-checkbox .el-checkbox__label{
    font-size: 10px;
  }
  .btn-register{
    padding: 10px 24px;
  }
  .btn-login{
    padding: 10px 13px;
  }
  .div_qr{
    max-width: 190px;
    margin: 0 auto;
  }
  .hddk_ctlh .hddk_ctlh-a{
    font-size: 8px;
  }
  .hdsd .hdsd-a{
    font-size: 8px;
  }
  .phone-switchboard .switchboard-text{
    font-size: 10px;
    padding-top: 4px;
  }
  .phone-switchboard .phone{
    font-size: 14px;
    padding-bottom: 0;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
   .card-content-form .form-login-custom .forgot-pass{
    flex: 0 0 100%;
    max-width: 100%;
  }
  .card-content-form .form-login-custom .remember-pass{
    text-align: left;
  }
  .card-content-form .form-login-custom .forgot-pass{
    text-align: center;
  }
  .card-content-form .form-login-custom .forgot-pass a{
    padding-right: 10px;
  }
  .remember-pass .el-checkbox .el-checkbox__label{
    font-size: 10px;
  }
  .div_qr{
    max-width: 190px;
    margin: 0 auto;
  }
}
  ::v-deep .list_account .el-dialog {
    margin-top: 20vh !important;
    width: 600px !important ;
    height: auto !important;
  }
  ::v-deep .list_account .el-dialog .el-dialog__header {
    padding: 5px 10px;
    border-bottom: 1px solid #e4e7ed;
    background: #f0f3f5;
  }
  ::v-deep .list_account .el-dialog__headerbtn{
    width: 35px;
    height: 35px;
  }
  ::v-deep .list_account .el-dialog .el-dialog__body{
    padding: 15px;
  }
  @media (min-width: 500px ) and (max-width: 768px) {
    ::v-deep .list_account .el-dialog{
      width: 400px !important;
    }
  }
  @media (max-width: 499px) {
    ::v-deep .list_account .el-dialog{
      width: 300px !important;
    }
  }
</style>
<style>
.form-login-custom .el-form-login-custom .el-form-item__label{
  color: #0c66ad;
  font-weight: normal;
}
.form-login-custom .el-form-login-custom .el-form-item__content .el-input .el-input__inner{
  background-color: #f2f2f2;
  border: none;
}
.remember-pass .el-checkbox .el-checkbox__label{
  color: #0c66ad;
}
.form-login-custom .el-form-item.is-required:not(.is-no-asterisk).el-form-item__label-wrap>.el-form-item__label:before,
.form-login-custom .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
  content: '';
  margin-right: 4px;
}

</style>
